<template>
    <div>
        <AppButton @click="openPanel()" element="button">
            {{ $t('messages.select_students', { number: studentsCount }) }}
        </AppButton>

        <SlideOver :show="open" @close="open = false">
            <FormLabel :value="$t('messages.search')" for="search" />
            <FormInput
                required
                id="search"
                v-model.trim="search"
                name="search"
                type="text"
                max="60"
                class="mt-1 w-full"
                autocomplete="off"
            />

            <div class="flex mt-3">
                <AppButton @click="selectAll()" element="button">
                    {{ $t('messages.select_all') }}
                </AppButton>
                <AppButton @click="deselectAll()" element="button">
                    {{ $t('messages.deselect_all') }}
                </AppButton>
            </div>

            <div>
                <template v-for="(student, index) in filteredStudents" :key="index">
                    <ul class="mt-5">
                        <li class="flex space-x-2">
                            <div>
                                <input
                                    type="checkbox"
                                    name="selected_students"
                                    v-model="selectedIds"
                                    :value="student.id"
                                    :id="`student_${student.id}`"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                            </div>
                            <img
                                :src="student.avatar_or_default"
                                alt="profile photo"
                                class="relative z-30 inline-block h-10 w-10 rounded-full ring-2 ring-white"
                            />
                            <div>
                                {{ student.full_name }}
                                <span v-if="withCount">({{ student.count }})</span>
                            </div>
                        </li>
                    </ul>
                </template>
            </div>
        </SlideOver>
    </div>
</template>

<script>
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['update:modelValue'],
    name: 'StudentSelectorSlideOver',

    components: {
        SlideOver,
        FormInput,
        FormLabel,
        AppButton,
    },

    props: {
        withCount: {
            required: false,
            type: Boolean,
            default: false,
        },
        students: {
            required: true,
            type: Array,
            default: () => [],
        },
        modelValue: {
            required: true,
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            open: false,
            search: '',
            selectedIds: this.modelValue,
        };
    },

    watch: {
        selectedIds(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },

    computed: {
        studentsCount: function () {
            return this.students.length;
        },
        selectedStudentsCount: function () {
            return this.selectedIds ? this.selectedIds.length : this.students.length;
        },
        filteredStudents: function () {
            let filteredStudents = [...this.students];

            if (this.search !== '') {
                filteredStudents = filteredStudents.filter((s) => s.full_name.includes(this.search));
            }

            return filteredStudents;
        },
    },

    methods: {
        deselectAll() {
            this.selectedIds = [];
        },
        selectAll() {
            this.selectedIds = this.students.map((x) => x.id);
        },
        openPanel() {
            this.open = true;
        },
    },
};
</script>
